import { render, staticRenderFns } from "./SettingLevel.vue?vue&type=template&id=87fa56a8"
import script from "./SettingLevel.vue?vue&type=script&lang=js"
export * from "./SettingLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports